import './chunk-f2006744.js';
import './chunk-7b019b33.js';
import './chunk-b170726a.js';
import './chunk-7d95d17c.js';
import './chunk-1d58fda4.js';
import { r as registerComponent, u as use } from './chunk-cca88db8.js';
import './chunk-bf9499d9.js';
import { A as Autocomplete } from './chunk-c1f1b4c0.js';
export { A as BAutocomplete } from './chunk-c1f1b4c0.js';

var Plugin = {
  install: function install(Vue) {
    registerComponent(Vue, Autocomplete);
  }
};
use(Plugin);

export default Plugin;
